/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TelemetryEntity = {
    telemetryID: number;
    type: TelemetryEntity.type;
    data: Record<string, any>;
    createdAt: string;
};
export namespace TelemetryEntity {
    export enum type {
        SCAN_DATA = 'SCAN_DATA',
        EVENT_DATA = 'EVENT_DATA',
        DEVICE_DATA = 'DEVICE_DATA',
    }
}

